<mat-dialog-content>
  <div
    class="light-bg-color row-layout"
    style="
      justify-content: center;
      font-size: 4rem;
      line-height: 4rem;
      padding-top: 4px;
    "
  >
    <div class="row-layout">
      <div style="padding-right: 0.5rem">
        <span class="time-picker-top" [ngClass]="tcs[0]" (click)="tc(true)"
          >{{_hours}}</span
        >
      </div>
      <div><span>:</span></div>
      <div style="padding-left: 0.5rem">
        <span class="time-picker-top" [ngClass]="tcs[1]" (click)="tc(false)"
          >{{_minutes}}</span
        >
      </div>
    </div>
  </div>
  <div *ngIf="version==2">
    <ng-container *ngIf="_hoursView">
      <div
        *ngFor="let o of hStyles"
        class="row-layout"
        style="margin: 2rem 0; padding: 0 4px; justify-content: space-between"
      >
        <button
          mat-button
          *ngFor="let h of o"
          style="border-width: 1px; border-style: solid; min-width: 48px"
          [ngStyle]="{
          'font-size': h.l ? '1.6rem': '1rem'
        }"
          (click)="oc(h.v, true)"
        >
          {{h.v}}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="!_hoursView">
      <div
        *ngFor="let o of mStyles"
        class="row-layout"
        style="margin: 2rem 0; padding: 0 4px; justify-content: space-between"
      >
        <button
          mat-button
          *ngFor="let h of o"
          style="border-width: 1px; border-style: solid; min-width: 48px"
          [ngStyle]="{
          'font-size': h.l ? '1.6rem': '1rem'
        }"
          (click)="oc(h.v, false)"
        >
          {{h.v}}
        </button>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="version==1"
    class="row-layout"
    style="justify-content: center; padding: 1rem 0 1rem 0"
  >
    <div
      #content
      style="
        border-radius: 50%;
        position: relative;
        background: #ededed;
        cursor: pointer;
      "
      [ngStyle]="mainStyle"
      (click)="onClick($event)"
    >
      <ng-container *ngIf="_hoursView">
        <button
          *ngFor="let o of hStyles"
          style="
            position: absolute;
            border-width: 0;
            border-radius: 50%;
            font-weight: 400;
          "
          [ngClass]="'my-number'"
          [ngStyle]="{
      left:o.left+'px',
      top:o.top+'px'
    }"
          (click)="oc(o.i, true)"
        >
          {{o.val}}
        </button>
      </ng-container>
      <ng-container *ngIf="!_hoursView">
        <ng-container *ngFor="let o of mStyles">
          <button
            *ngIf="o.i%5==0"
            style="
              position: absolute;
              border-width: 0;
              border-radius: 50%;
              font-weight: 400;
            "
            [ngClass]="o.i%5==0?'my-number':'my-minute-dot'"
            [ngStyle]="{
          left:o.left+'px',
          top:o.top+'px'
        }"
            (click)="oc(o.i, false)"
          >
            {{o.val}}
          </button>
          <div
            *ngIf="o.i%5!=0"
            style="
              position: absolute;
              border-width: 0;
              border-radius: 50%;
              font-weight: 400;
            "
            [ngClass]="o.i%5==0?'my-number':'my-minute-dot'"
            [ngStyle]="{
          left:o.left+'px',
          top:o.top+'px'
        }"
            (click)="oc(o.i, false)"
          ></div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row-layout" style="justify-content: flex-end; width: 100%">
    <button
      mat-button
      class="my-primary"
      style="margin-right: 1rem"
      (click)="onClose(false)"
    >
      {{cancelLabel}}
    </button>
    <button
      mat-button
      class="my-primary"
      (click)="onClose(true)"
      cdkFocusInitial
    >
      {{okLabel}}
    </button>
  </div>
</mat-dialog-actions>
